module.exports = __webpack_public_path__ + "img/panicbutton.8dfb46c3.svg";